import React from "react";

import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from "react-bootstrap";

import { NavLink } from "react-router-dom";

import { FaFacebookF, FaInstagram, FaPinterest, FaTwitter, FaYoutube, FaCheck, FaSketch, FaOpencart } from "react-icons/fa";
import { BsSendCheck, BsFill1CircleFill, BsFill2CircleFill, BsCheckLg, BsFillRecordFill, BsFacebook, BsInstagram, BsTelephone, BsSend, BsTiktok, BsDownload, BsApple, BsAndroid2 } from "react-icons/bs";

function DownloadApp() {

    return (

        <Container>

            <br/>

            <h3><strong><BsDownload /> ดาวน์โหลดแอพพลิเคชั่น</strong></h3>
          
            <h3 className="pb-3 border-bottom"></h3>
            <br/>
            {/* <h4><strong>ที่อยู่ EnqueX</strong></h4>
            <p>เลขที่ 199/288 แขวงสีกัน เขตดอนเมือง กรุงเทพมหานคร รหัสไปรษณีย์ 10210</p>

            
          
            <br/> */}

            <h4><a href="https://apps.apple.com/th/app/edulaw/id6503618185" target="_blank" rel="noreferrer" style={{textDecoration: 'none'}}><BsApple /> EduLaw - ios</a></h4>
            <h4><a href="https://play.google.com/store/apps/details?id=com.testrn02&hl=th" target="_blank" rel="noreferrer" style={{textDecoration: 'none'}}><BsAndroid2 /> EduLaw - Android</a></h4>
            
            
            {/* โทรศัพท์ - <BsTelephone/> 0805514821</p> */}

            

            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
           
            

        </Container>

    );

}

export default DownloadApp;